<template>
  <el-dialog title="修改地址" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" :close-on-click-modal="handleClose" append-to-body>
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item label="公司地址:">
          <div class="weui-cell" style="padding: 0">
            <div class="weui-cell__bd">
              <el-input v-model="form.company_address" placeholder="详细地址,将显示于小程序官网"></el-input>
            </div>
            <div class="weui-cell__ft ml10">
              <el-button type="primary" @click="filterkeyword">定位地址</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="地图定位:">
          <div id="container" style="width:100%;height:500px;">
            <div class="containerMap"><img src="/static/img/centerAdress.png" alt=""></div>
          </div>
          *只用于获取位置坐标
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="onSubmit" size="small">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: "enterpriseAddressDialog",
  props: ["visible","formData"],
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        location: "",
        company_address:''
      },
      options: [],
      handleClose: false,
      mapSearchType: 1, // 1 逆解析 2 地址解析
      mapInfo: {
        longitude: '',//经度
        latitude: '',//纬度
        city: '',
        zoom: 17,
        map: null, // 初始化地图
        geocoder: null, // 地址搜索
        marker: null // 标注提示
      }
    };
  },
  created() {

  },
  methods: {
    onSubmit() {
      if (!this.form.company_address) {
        this.$message.error('请填写公司地址');
        return
      }
      this.$emit('editFrom',{map:this.mapInfo,company_address:this.form.company_address});
    },
    getMyLocation() {
      if (!this.form.location) {
        this.form.location = localStorage.getItem("location") || "24.491234,118.194489";
      } 
      this.mapInfo.latitude = this.form.location.split(',')[1];
      this.mapInfo.longitude = this.form.location.split(',')[0];      
      this.init();
    },
    //成功获取地址
    showPosition(position) {
      this.mapInfo.latitude = position.lng;
      this.mapInfo.longitude = position.lat;
      this.init();
    },
    // 获取地址失败
    showErr() {
      this.getMyLocation();//定位失败再请求定位，测试使用
    },
    init() {
      //步骤：定义map变量 调用 qq.maps.Map() 构造函数 获取地图显示容器
      // 设置地图中心点
      let this_ = this;
      let myLatlng = new qq.maps.LatLng(this.mapInfo.longitude, this.mapInfo.latitude); //定义工厂模式函数
      let myOptions = {
        zoom: this.mapInfo.zoom, //设置地图缩放级别
        center: myLatlng, //设置中心点样式
        mapTypeControl: false,
        panControl: false,
        zoomControl: false,
        draggable: false,
        scrollwheel: false,
        disableDoubleClickZoom: false
      }

      // 获取dom元素添加地图信息
      this.mapInfo.map = new qq.maps.Map(document.getElementById("container"), myOptions);
      //给定位的位置添加图片标注
      this.mapInfo.marker = new qq.maps.Marker({
        position: myLatlng,
        map: this.mapInfo.map
      });
      // let anchor = new qq.maps.Point(0, 39);
      let size = new qq.maps.Size(40, 40);
      let origin = new qq.maps.Point(0, 0);
      let icon = new qq.maps.MarkerImage(
          "/static/img/adressMap.png",
          size,
          origin
      );
      this.mapInfo.marker.setIcon(icon);
      this.mapInfo.geocoder = new qq.maps.Geocoder({
        complete: function (result) {
          this_.form.location = result.detail.location.lat+','+result.detail.location.lng
          if (this_.mapSearchType === 2) {
            this_.LatLngMap(result.detail.location.lat, result.detail.location.lng);
          } else {
            this_.form.company_address = result.detail.address
          }
        }
      });
    },
    LatLngMap(lat, lng) {
      this.form.location = lat+','+lng;
      let latLng = new qq.maps.LatLng(lat, lng);
      let this_ = this;
      if (this.mapSearchType === 2) {
        let myOptions = {
          zoom: this.mapInfo.zoom, //设置地图缩放级别
          center: latLng, //设置中心点样式
          mapTypeControl: false,
          panControl: false,
          zoomControl: false,
          draggable: false,
          scrollwheel: false,
          disableDoubleClickZoom: false
        }
        // 获取dom元素添加地图信息
        this.mapInfo.map = new qq.maps.Map(document.getElementById("container"), myOptions);
      }
      this.mapInfo.marker.setMap(null);
      this.mapInfo.marker = new qq.maps.Marker({
        position: latLng,
        map: this_.mapInfo.map
      });
      let size = new qq.maps.Size(40, 40);
      let origin = new qq.maps.Point(0, 0);
      let icon = new qq.maps.MarkerImage(
          "/static/img/adressMap.png",
          size,
          origin
      );
      this.mapInfo.marker.setIcon(icon);
      if (this.mapSearchType === 1) {
        this.mapInfo.geocoder.getAddress(latLng);
      }
    },
    filterkeyword() {
      this.mapSearchType = 2; // 1 逆解析 2 地址解析
      if (this.form.company_address) {
        this.mapInfo.geocoder.getLocation(this.form.company_address);  
      } else {
        var geolocation = new qq.maps.Geolocation("BN7BZ-EA3WW-BSVR6-RZ26N-27YAZ-NGBDW", "名片地图地址");
        geolocation.getIpLocation(this.showPosition, this.showErr);
      }
    }
  },
  mounted() {
    this.$emit('update:property', this.form);
    this.$nextTick(function (){
      this.getMyLocation()
    })

  },
  watch: {
    formData: {
      immediate: true,
      handler(val) {
        this.form = val
      }
    },
    visible() {
      this.dialogVisible = this.visible;
    }
  },
};
</script>

